module.exports = __webpack_public_path__ + "img/plan_znief1.8d051332.jpg";